import PropTypes from 'prop-types';
// material
import { visuallyHidden } from '@mui/utils';
import { Box, Checkbox, TableRow, TableCell, TableHead, TableSortLabel } from '@mui/material';

// ----------------------------------------------------------------------

UserListHead.propTypes = {
  order: PropTypes.oneOf(['asc', 'desc']),
  orderBy: PropTypes.string,
  rowCount: PropTypes.number,
  headLabel: PropTypes.array,
  numSelected: PropTypes.number,
  onRequestSort: PropTypes.func,
  onSelectAllClick: PropTypes.func
};

export default function UserListHead({
  order,
  orderBy,
  rowCount,
  headLabel,
  numSelected,
  onRequestSort,
  onSelectAllClick,
  textStyle,
  onClick,
  allSelect
}) {
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headLabel.map((headCell) => (
          <TableCell
            style={{
              paddingLeft: headCell.paddingLeft && headCell.paddingLeft,
              cursor: 'default'
            }}
            padding="normal"
            key={headCell.id}
            align={headCell.alignCenter ? 'center' : headCell.alignRight ? 'right' : 'left'}
            sortDirection={orderBy === headCell.id ? order : false}
            flexDirection={'row'}
          >
            {headCell.id !== 'Select' && (
              <TableSortLabel
                hideSortIcon
                style={{
                  cursor: 'default',
                  pointerEvents: 'none',
                  color: 'inherit'
                }}
                onClick={onClick}
              >
                {headCell.label}
              </TableSortLabel>
            )}

            {headCell.id == 'Select' && (
              <Checkbox checked={allSelect} onChange={onSelectAllClick} />
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
